/* global $:false */

import window from 'window'

export default class LotGalleryPinch {
  static init () {
    Array.from($('.js-lot-carousel')).map((el) =>
      new LotGalleryPinch(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.observePinchZoom()
    this.observeCarouselScroll()
  }

  findElements () {
    this.images = this.el.find('.js-lot-carousel-image')
  }

  observePinchZoom () {
    // Waiting for the polyfill to be loaded.
    window.addEventListener('load', () => {
      window.visualViewport.addEventListener('resize', () => {
        this.zoomed = window.visualViewport.scale > 1
        this.viewportChanged()
      })

      window.visualViewport.addEventListener('scroll', () => {
        this.viewportChanged()
      })
    })
  }

  observeCarouselScroll () {
    this.el.on('scroll', () => this.viewportChanged())
  }

  viewportChanged () {
    if (this.throttle) { return }
    if (!this.zoomed) { return }
    this.throttle = setTimeout(() => {
      this.update()
      this.throttle = null
    }, 300)
  }

  update () {
    for (const image of Array.from(this.images)) {
      if (this.imageIsInViewport(image)) {
        this.upgradeImage(image)
      }
    }
  }

  imageIsInViewport (image) {
    image = $(image)
    const imageLeft = image.offset().left
    const imageRight = image.offset().left + image.width()
    const carouselLeft = this.el.offset().left
    const carouselRight = this.el.offset().left + this.el.width()
    const threshold = 50

    if (imageRight < (carouselLeft + threshold)) { return }
    if (imageLeft > (carouselRight - threshold)) { return }
    return true
  }

  upgradeImage (image) {
    image = $(image)
    const fullsizeUrl = image.data('zoom')
    if (image.attr('src') === fullsizeUrl) { return }
    this.showSpinner(image)
    const newImage = new window.Image()
    newImage.src = fullsizeUrl
    newImage.onload = () => {
      image.attr('src', fullsizeUrl)
      this.hideSpinner(image)
    }
  }

  showSpinner (image) {
    $(image).prevAll('.js-lot-carousel-spinner').show()
  }

  hideSpinner (image) {
    $(image).prevAll('.js-lot-carousel-spinner').hide()
  }
}
